<template>
  <b-field class="image-upload"
    :label="`${label}${isSaved?'':'*'}`"
    :addons="false"
    :class="{'has-image' : !!image}"
    :horizontal="horizontal">
    <b-upload
      class="upload-input"
      :style="{backgroundImage: image ? `url(${imageSrc})`: null}"
      drag-drop
      type="is-primary" @input="(f) => $emit('input', f)"
      :accept="accept">
      <section class="upload-action has-text-centered has-text-primary">
        <p><b-icon icon="upload" size="is-large"/></p>
        <p>Upload</p>
      </section>
    </b-upload>
  </b-field>
</template>
<script>

export default {
  props: ['image', 'isSaved', 'label', 'horizontal', 'accept'],
  computed: {
    imageSrc() {
      if (this.image && typeof this.image === 'object') {
        return URL.createObjectURL(this.image);
      }
      return this.image;
    },
  },
};
</script>

<style lang="scss" scoped>

/deep/ .upload-draggable {
  width: 100%;
  padding: 0;
}

.image-upload {
  border-radius: 5px;
}

.upload-input {
  display: block;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  border-radius: 5px;
}

.upload-action {
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.has-image {
  position: relative;

  .upload-action {
    opacity: 0;
  }

  &:hover {
    .upload-action {
      opacity: 1;
    }
  }
}

</style>
